"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GeneralServiceError extends Error {
    constructor(message, errorCode) {
        super(message);
        this.errorCode = errorCode;
        this.name = 'GeneralServiceError';
    }
}
exports.default = GeneralServiceError;
//# sourceMappingURL=GeneralServiceError.js.map